<template>
  <div class="info">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>
    <div class="w">
      <!-- 面包屑导航 -->
      <div class="ac1-list">
        <div class="my-container">
          <h2>所在位置：</h2>
          <a href="/">首页</a> <span>></span> <a href="/#/pay">会员专区</a>
        
        </div>
      </div>
      
      <div class="pay-img">
        <img src="/imgs/pay1.png" alt="">
      </div>


      <div class="pay-img2">
        <img src="/imgs/pay2.png" alt="" @click="alipay({},1,20)">
        <img src="/imgs/pay3.png" alt="" @click="alipay({},1,40)">
        <img src="/imgs/pay4.png" alt="" @click="alipay({},1,80)">
        <img src="/imgs/pay5.png" alt="" @click="alipay({},1,150)">
      </div>
     
      <!-- modal 弹框 -->
      <modal
        title="图片"
        btnType="1"
        modalType="middle"
        :showModal="showModal"
        @submit="showModal = false"
        @cancel="showModal = false"
      >
        <template v-slot:body>
          <img :src="imgUrl" />
          <p>动漫收费下载：2元</p>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import Modal from "../components/Modal.vue";
export default {
  name: "info",
  components: { NavHeader, Modal },
  data() {
    return {
      state: JSON.parse(window.localStorage.getItem("state")),
      logo_user: JSON.parse(window.localStorage.getItem("user")),
      href: "/",
      cm1: [],
      cm2: [],
      cm3: [],
      cm4: [],
      cm5: [],
      cm6: [],
      cm7: [],
      cm8: [],
      cm9: [],
      showModal: false,
      imgUrl: "/imgs/pay.png",
    };
  },
  mounted() {
    this.init();
    document.title = "晋江奇境";
  },
  methods: {
    // 真实支付逻辑
    alipay(data, index, price) {
      console.log(data);
      var payAmount = price; //支付价格
      var orderName = "会员支付下载"; //订单名称
      var id = index; //订单名称
      var userName = this.logo_user.username;
      window.open(
        "http://www.jjqj.net/alipay/index.php?payAmount=" +
          payAmount +
          "&orderName=" +
          orderName +
          "&id=" +
          id +
          "&userName=" +
          userName
      );
    },
    // 渲染数据
    init() {
      this.axios.get("/mock/a.json").then((res) => {
        var data = res.data;
        this.cm1 = data.slice(0, 21);
      });
    },
    // 收费逻辑
    gopay() {
      // console.log('1')
      alert("请付费下载图片！");
      this.showModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.info {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f1f5f7;
  .w {
    padding: 40px 0;
    box-sizing: border-box;

    .banner {
      width: 100%;
      height: 400px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    // 面包屑
    .ac1-list {
      width: 100%;
      margin: 30px 0;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 15px;
      box-sizing: border-box;
      .my-container {
        display: flex;
        align-items: center;
        height: 100%;
        h2 {
          font-size: 21px;
        }

        a {
          font-size: 18px;
          // font-weight: bold;
          color: #333;
          text-decoration: none;
          &:nth-child(6) {
            color: $colorZ;
          }
        }

        span {
          font-size: 18px;
          color: #333;
          margin: 0 15px;
        }
      }
    }
  .pay-img {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .pay-img2 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    img {
      width: 280px;
      cursor: pointer;
      transition: all .3s;
      &:hover {
        transform: translateY(-15px);
      }
    }
  }
   
  }
}
</style>
